__turbopack_context__.v({
  "className": "raster_99952dfc-module__LhItRa__className",
  "variable": "raster_99952dfc-module__LhItRa__variable",
});
